import { render, staticRenderFns } from "./articel.vue?vue&type=template&id=59cdbf93&scoped=true&"
import script from "./articel.vue?vue&type=script&lang=js&"
export * from "./articel.vue?vue&type=script&lang=js&"
import style0 from "./articel.vue?vue&type=style&index=0&id=59cdbf93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cdbf93",
  null
  
)

export default component.exports